import React, { useState } from 'react';
import searchIcon from '../../assets/images/dashboard/body/Search.svg'

const FindCategory = ({ onLogin }) => {
    const [search, setSearch] = useState('');
    const [categories] = useState([
        'Add category',
        'Category 1',
        'Category 2',
        'Category 3',
        'Category 4',
    ]);
    const [selectedCategories, setSelectedCategories] = useState([]);

    const handleSelectCategory = (category) => {
        if (!selectedCategories.includes(category)) {
            setSelectedCategories([...selectedCategories, category]);
        }
    };

    const handleRemoveCategory = (category) => {
        setSelectedCategories(
            selectedCategories.filter((item) => item !== category)
        );
    };


    return (
        <div>
            <div className="flex items-center justify-center h-screen">
                <div className="relative w-fit items-center flex justify-center flex-col ">

                    <button className='absolute right-3 top-4 text-black' onClick={onLogin}>
                        &#10006;
                    </button>

                    <div className="w-80 p-4 border rounded-md shadow-sm bg-white">
                        <h3 className="mb-2 font-semibold">Category</h3>
                        <div className="relative">
                            <input
                                type="text"
                                placeholder="Search Categories"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                className="w-full pl-10 pr-4 py-2 border rounded-md focus:outline-none"
                            />

                            <div className="absolute top-[14px] left-3 text-gray-400">
                                <img src={searchIcon} alt="searchIcon" />
                            </div>

                            <div className="flex flex-wrap gap-2 mt-2">
                                {selectedCategories.map((category, index) => (
                                    <div
                                        key={index}
                                        className="flex items-center gap-2 bg-purple-200 text-purple-800 px-2 py-1 rounded-md"
                                    >
                                        {category}
                                        <button
                                            onClick={() => handleRemoveCategory(category)}
                                            className="text-purple-600"
                                        >
                                            ✕
                                        </button>
                                    </div>
                                ))}
                            </div>

                            <div className="mt-2 border rounded-md max-h-40 overflow-y-auto">
                                {categories.map((category, index) => (
                                    <label
                                        key={index}
                                        className="flex items-center gap-2 p-2 cursor-pointer hover:bg-gray-100"
                                    >
                                        <input
                                            type="checkbox"
                                            checked={selectedCategories.includes(category)}
                                            onChange={() => handleSelectCategory(category)}
                                            className="form-checkbox text-purple-500"
                                        />
                                        {category}
                                    </label>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FindCategory;
